import { FC } from 'react';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import Typography from 'components/commercetools-ui/atoms/typography';
import useImageSizes from 'helpers/hooks/useImageSizes';
import { ContentSliderSlideProps } from './types';
import Image from 'frontastic/lib/image';
import usePreloadImages from 'helpers/hooks/usePreloadImages';
import Link from 'components/commercetools-ui/atoms/link';
import useWindowWidth from 'helpers/hooks/useBrowerWidth';


const ContentSliderSlide: FC<ContentSliderSlideProps> = ({ image, card_title, ctas, summary, card_description, additional_css }) => {
  const width = useWindowWidth();

  const link = `w-100 overflow-hidden relative ${card_description ? 'h-auto' : 'h-auto'} h-auto`;
  usePreloadImages([image?.url]);

  return (
    <Link link={ctas?.[0]?.button?.href} className={`${link} group`}>
      {image && (
        <div className={`discover-bg ${additional_css} group-hover:bg-[#fafdf3]`}>
          <Image
              priority
              loading='eager'
              src={encodeURI(image?.url)}
              alt={card_title}
              sizes="100vw"
              style={{
                width: '100%',
                height: `${width !== null && width < 531 ? '120px' : '100%'}`,
                maxWidth: '650px',
                objectFit: 'cover',
              }}
              width={500}
              height={300}
              />
        </div>
      )}

      <div className="lg:px-[20px] lg:pb-[10px]">
      {card_title && (
          <Typography
            as="h4"
            className={`mt-10 flex flex-col  text-16 font-medium leading-[20px] text-[#FFFFFF] md:text-16 lg:text-20 xl:text-18 2xl:text-22 relative ${width !== null && width < 385 ? 'min-h-[68px]' : ''}  ${width !== null && width < 570 ? 'min-h-[50px]' : ''}`}
          >
            {card_title}
          </Typography>
          )}
        {ctas && (
          <div className={`group-hover:translate-x-14`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="green">
              <path
                d="M18 9L25 16M25 16L18 23M25 16L7 16"
                stroke="#ffffff"
                className=" group-hover:stroke-[#ffffff] block-md"
                strokeWidth="2"
                strokeLinecap="square"
              />
            </svg>
          </div>
        )}
      </div>
    </Link>
  );
};

export default ContentSliderSlide;
